const invert = require('lodash/invert');

const skus = {
  LMN: 'lmn',
  TJH: 'tjh',
  KOY: 'kingdom-of-you',
  TBT: 'birthday-thief',
  MGT: 'my-golden-ticket',
  TLB: 'littlest-bear',
  SCS: 'snowflake',
  MLM: 'little-monsters',
  TWR: 'wondrous-road',
  TPW: 'power-within',
  WAY: 'where-are-you',
  FMF: 'found-my-friends',
  MMK: 'magboggle-mystery',
  MSV: 'my-voice',
  ESC: 'elf-who-saved-christmas',
  WAB: 'where-are-you-activity-book',
  BFN: 'bedtime-for-name',
  WKN: 'what-kind-of-name',
  HBY: 'happy-birthday-to-you',
  TMC: 'thats-my-cake',
  DTD: 'dared-to-dream',
  YAE: 'you-are-extraordinary',
  WA2: 'where-are-you-2',
  DRT: 'dream-town',
  WWA: 'wonderbly-activity',
  CWY: 'christmas-wishes',
  ILY: 'i-love-you-this-much',
  IL2: 'i-love-you-this-much-v2',
  DLY: 'you-love-daddy-this-much',
  DL2: 'you-love-daddy-this-much-v2',
  GL2: 'you-love-grandma-this-much-v2',
  GD2: 'you-love-grandad-this-much-v2',
  MLY: 'you-love-mummy-this-much',
  ML2: 'you-love-mummy-this-much-v2',
  YLT: 'you-love-them-this-much',
  YL2: 'you-love-them-this-much-v2',
  YFY: 'y-is-for-you',
  DFY: 'daycare-for-you',
  WCY: 'who-can-you-can',
  BED: 'best-dad-ever',
  BEM: 'best-mum-ever',
  BEB: 'best-ever',
  TLY: 'ten-little-yous',
  YAB: 'you-and-the-beanstalk',
  AYB: 'activity-book',
  CAB: 'coloring-activity-book',
  CGB: 'coloring-book',
  YBP: 'your-birthday-party',
  YCB: 'your-colors',
  NSB: 'new-sibling-for-you',
  RRB: 'remarkable-rebels',
};

const slugs = {
  LMN: 'lost-my-name-book',
  TJH: 'the-journey-home-book',
  KOY: 'kingdom-of-you-book',
  TBT: 'the-birthday-thief-book',
  MGT: 'roald-dahl-my-golden-ticket-book',
  TLB: 'the-littlest-bear-book',
  SCS: 'the-christmas-snowflake-book',
  MLM: 'my-little-monster-name-book',
  TWR: 'the-wondrous-road-book',
  TPW: 'the-power-within-book',
  WAY: 'where-are-you-book',
  FMF: 'found-my-friends-book',
  MMK: 'the-curious-case-of-the-magboggle-mystery-kit',
  MSV: 'my-voice-book',
  ESC: 'elf-who-saved-christmas-book',
  WAB: 'where-are-you-activity-book',
  BFN: 'bedtime-for-name-book',
  WKN: 'what-kind-of-name-book',
  HBY: 'happy-birthday-to-you-book',
  TMC: 'thats-my-cake-book',
  DTD: 'dared-to-dream-book',
  YAE: 'you-are-extraordinary-book',
  WA2: 'where-are-you-2-book',
  DRT: 'dream-town-sticker-book',
  WWA: 'the-world-of-wonderbly-activity-book',
  CWY: 'christmas-wishes-book',
  ILY: 'i-love-you-this-much-book',
  IL2: 'i-love-you-book',
  GL2: 'you-love-grandma-book',
  GD2: 'i-love-you-grandad-book',
  DLY: 'you-love-daddy-this-much-book',
  DL2: 'you-love-daddy-book',
  MLY: 'you-love-mummy-this-much-book',
  ML2: 'you-love-mummy-book',
  YLT: 'you-love-them-this-much-book',
  YL2: 'you-love-them-book',
  YFY: 'abc-for-you-book',
  DFY: 'daycare-for-you-book',
  WCY: 'who-can-you-can-book',
  BED: 'best-dad-ever-book',
  BEM: 'best-mum-ever-book',
  BEB: 'best-ever-book',
  TLY: 'ten-little-yous-book',
  YAB: 'jack-and-the-beanstalk-book',
  AYB: 'activity-book',
  CAB: 'coloring-activity-book',
  CGB: 'coloring-book',
  YBP: 'your-birthday-party-book',
  YCB: 'your-colors-book',
  NSB: 'new-sibling-for-you-book',
  RRB: 'remarkable-rebels-book',
};


const museEndpoints = {
  ...skus,
  // Overrides for when we want to use same muse endpoint for multiple skus
  BED: 'best-ever',
  BEM: 'best-ever',
  IL2: 'i-love-you-this-much-v2',
  ML2: 'i-love-you-this-much-v2',
  DL2: 'i-love-you-this-much-v2',
  GL2: 'i-love-you-this-much-v2',
  GD2: 'i-love-you-this-much-v2',
};
// Used to calculate ratio in the book previews
const dimensions = {
  LMN: {
    width: 1280,
    height: 923,
  },
  TJH: {
    width: 1280,
    height: 906,
  },
  KOY: {
    width: 1280,
    height: 905,
  },
  TBT: {
    width: 1280,
    height: 906,
  },
  TLB: {
    width: 1280,
    height: 768,
  },
  SCS: {
    width: 1280,
    height: 768,
  },
  MLM: {
    width: 1280,
    height: 1280,
  },
  TWR: {
    width: 1280,
    height: 905.33,
  },
  FMF: {
    width: 1280,
    height: 906,
  },
  MGT: {
    width: 896,
    height: 1218,
  },
  TPW: {
    width: 896,
    height: 1218,
  },
  WAY: {
    width: 1227,
    height: 1575,
  },
  ESC: {
    width: 1280,
    height: 906,
  },
  BFN: {
    width: 1280,
    height: 1280
  },
  WKN: {
    width: 1280,
    height: 1280
  },
  HBY: {
    width: 1280,
    height: 1280
  },
  TMC: {
    width: 1280,
    height: 906,
  },
  DTD: {
    width: 1280,
    height: 906,
  },
  YAE: {
    width: 896,
    height: 1218,
  },
  DRT: {
    width: 896,
    height: 1218,
  },
  WA2: {
    width: 1227,
    height: 1575,
  },
  CWY: {
    width: 1280,
    height: 906,
  },
  ILY: {
    width: 1280,
    height: 1280,
  },
  DLY: {
    width: 1280,
    height: 1280,
  },
  MLY: {
    width: 1280,
    height: 1280,
  },
  YLT: {
    width: 1280,
    height: 1280,
  },
  YFY: {
    width: 1280,
    height: 1280
  },
  DFY: {
    width: 1280,
    height: 1280
  },
  WCY: {
    width: 1280,
    height: 1280
  },
  BED: {
    width: 896,
    height: 1218,
  },
  BEM: {
    width: 896,
    height: 1218,
  },
  BEB: {
    width: 896,
    height: 1218,
  },
  TLY: {
    width: 1280,
    height: 1280,
  },
  YAB: {
    width: 1280,
    height: 906,
  },
  YBP: {
    width: 1280,
    height: 905,
  },
  YCB: {
    width: 1280,
    height: 1280,
  },
  NSB: {
    width: 1280,
    height: 1280,
  },
  RRB: {
    width: 896,
    height: 1218,
  },
  IL2:{
    width: 1280,
    height: 1280,
  },
  DL2:{
    width: 1280,
    height: 1280,
  },
  ML2:{
    width: 1280,
    height: 1280,
  },
  YL2:{
    width: 1280,
    height: 1280,
  },
  GL2:{
    width: 1280,
    height: 1280,
  },
  GD2:{
    width: 1280,
    height: 1280,
  },
};

const findKeyBy = {
  sku: sku => invert(skus)[sku],
  slug: slug => invert(slugs)[slug],
};

const getProductByKey = key => ({
  sku: skus[key],
  slug: slugs[key],
  dimensions: dimensions[key]
});

const getProductBySlug = slug => {
  return getProductByKey(findKeyBy.slug(slug));
};

const getProductSlugByKey = key => {
  return slugs[key];
};

const getProductSlugBySku = sku => {
  return slugs[findKeyBy.sku(sku)];
};

module.exports = {
  skus,
  slugs,
  dimensions,
  museEndpoints,
  findKeyBy,
  getProductByKey,
  getProductBySlug,
  getProductSlugByKey,
  getProductSlugBySku,
};
